import React from 'react';
import { Table, TableColumnsType } from 'antd';
import VehicleAuctionHistory from '../../../core/models/VehicleAuctionHistory';
import { convertToCurrencyString } from '../../../utils/currencyUtil';
import { Bid } from '../../../core/models/Bid';
import { formatDateTime } from '../../../utils/dateTimeUtil';

interface IProps {
  vehicleAuctionHistory: VehicleAuctionHistory[] | undefined;
}

const ViewVehicleAuctionHistory: React.FC<IProps> = ({vehicleAuctionHistory}) => {
  const expandedRowRender = (record: VehicleAuctionHistory) : any => {
    const columns: TableColumnsType<Bid> = [
      { title: 'Buyer', dataIndex: ['buyer', 'name'], key: 'buyer' },
      {
        title: 'Bid',
        dataIndex: 'bidPrice',
        key: 'bidPrice',
        render: (amount: number) => convertToCurrencyString(amount),
      },
    ];

    const data = record.bids ?? [];
    
    return <Table columns={columns} dataSource={data} pagination={false} size='small' />;
  };

  const columns: TableColumnsType<VehicleAuctionHistory> = [
    { title: 'Auction Title', dataIndex: 'auctionTitle', key: 'auctionTitle' },
    { title: 'Auction Date', dataIndex: 'auctionDateTime', key: 'auctionDateTime', render: (date: Date) => formatDateTime(date), },
  ];

  return (
    <Table
        rowKey={(record) => record.id}
        columns={columns}
        expandable={{ expandedRowRender }}
        dataSource={vehicleAuctionHistory}
        size="small"
      />
  );
};

export default ViewVehicleAuctionHistory;
